import { _ROLES_BACK } from "../../utils/constants";
import { BaseBudgetInput } from "../../components/budget/BaseBudgetInput";
import { TableWasteRate } from "../../components/budget/waste-rate/TableWasteRate";

export const InputWasteRate = () => {
  return (
    <BaseBudgetInput
      title="Input Waste Rate"
      roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL]}
      enableFlag="dataEntryEnableWasteRate"
      TableComponent={TableWasteRate}
    />
  );
};
